import React, { memo } from "react";

const Climate = memo(({ climate, year }) => {
  const formatChange = (value, suffix = "") => {
    const sign = value > 0 ? "+" : value < 0 ? "" : "";
    return `${sign}${value}${suffix}`;
  };

  const getTrendClassNegatif = (value) => (value >= 0 ? "trend-up" : "trend-down");
  const getTrendClassPositif = (value) => (value <= 0 ? "trend-up" : "trend-down");

  const getProgressWidth = (value, min, max) => {
    const clamped = Math.min(Math.max(value, min), max);
    const percent = ((clamped - min) / (max - min)) * 100;
    return `${percent}%`;
  };

  return (
    <div className="world-status">
      <div className="section-title">🌍 État du Monde</div>

      <div className="stats-grid">
        <div className="world-stat temperature">
          <div className="world-stat-header">
            <span className="world-stat-label">ANNÉE</span>
            <div>
              <span className="world-stat-value">{year}</span>
            </div>
          </div>
        </div>

        <div className="world-stat temperature">
          <div className="world-stat-header">
            <span className="world-stat-label">🌡️ Degré(s)</span>
            <div>
              <span className="world-stat-value">{formatChange(climate.degree, "°C")}</span>
              <span className={`world-stat-trend ${getTrendClassNegatif(climate.evolution.degree)}`}>
                {climate.evolution.degree >= 0 ? "↗" : "↘"} {formatChange(climate.evolution.degree, "°C")}
              </span>
            </div>
          </div>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: getProgressWidth(climate.degree, 0, 7),
                background: "linear-gradient(90deg, #fbbf24, #ef4444)",
              }}
            ></div>
          </div>
        </div>

        <div className="world-stat ocean">
          <div className="world-stat-header">
            <span className="world-stat-label">🌊 Océans</span>
            <div>
              <span className="world-stat-value">{formatChange(climate.ocean, "cm")}</span>
              <span className={`world-stat-trend ${getTrendClassNegatif(climate.evolution.ocean)}`}>
                {climate.evolution.ocean >= 0 ? "↗" : "↘"} {formatChange(climate.evolution.ocean, "cm")}
              </span>
            </div>
          </div>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: getProgressWidth(climate.ocean, 0, 150),
                background: "linear-gradient(90deg, #06b6d4, #3b82f6)",
              }}
            ></div>
          </div>
        </div>

        <div className="world-stat biodiversity">
          <div className="world-stat-header">
            <span className="world-stat-label">🦋 Biodiversité</span>
            <div>
              <span className="world-stat-value">{formatChange(climate.biodiversity, "%")}</span>
              <span className={`world-stat-trend ${getTrendClassPositif(climate.evolution.biodiversity)}`}>
                {climate.evolution.biodiversity >= 0 ? "↗" : "↘"} {formatChange(climate.evolution.biodiversity, "%")}
              </span>
            </div>
          </div>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: getProgressWidth(-climate.biodiversity, 0, 100), // inversion ici
                background: "linear-gradient(90deg, #ef4444, #dc2626)",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Climate;
